import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import UFOSegment from '@atlassian/jira-ufo-segment/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useIsOrgAdmin } from '@atlassian/jira-business-goal-picker/src/services/is-org-admin/index.tsx';
import { useIsSiteAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-site-admin/index.tsx';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';

import {
	Nav4Communications as Nav4CommunicationsWithoutErrorBoundary,
	type Nav4CommunicationsProps,
} from './ui/index.tsx';

import { PACKAGE_NAME, TEAM_NAME } from './common/constants.tsx';

export const Nav4Communications = (props: Nav4CommunicationsProps) => {
	const { isOrgAdmin } = useIsOrgAdmin();
	const isSiteAdmin = useIsSiteAdmin();
	const isAdmin = useIsAdmin();
	const shouldShowNav4 = getWillShowNav4();

	const isAdminUser = isOrgAdmin || isSiteAdmin || isAdmin;
	const showCommunicationMenu = fg('communications_stakeholder_management_platform') && isAdminUser;

	if (!showCommunicationMenu || !shouldShowNav4) {
		return null;
	}

	return (
		<UFOSegment name="nav4-sidebar-communications">
			<JSErrorBoundary
				fallback="flag"
				id="communications-section"
				packageName={PACKAGE_NAME}
				teamName={TEAM_NAME}
			>
				<Nav4CommunicationsWithoutErrorBoundary {...props} />
			</JSErrorBoundary>
		</UFOSegment>
	);
};
